import React, { PropsWithChildren, createContext, useContext } from "react";

import { attemptMethod } from "@utils/general";
import { isDefined } from "@utils/helpers";

export type LanguageContextValues = {
    getLocale: (getShortVersion?: boolean) => string;
};

export type LanguageContextProviderProps = PropsWithChildren<{ language: string }>;

export const LanguageContext = createContext<LanguageContextValues | undefined>(
    undefined,
);
LanguageContext.displayName = "LanguageContext";

export const LanguageContextProvider = ({
    children,
    language,
}: LanguageContextProviderProps) => {
    const getLocale = (getShortVersion = false) => {
        if (getShortVersion) {
            return attemptMethod(() => language.substring(0, 2), "");
        }
        return attemptMethod(() => language, "");
    };

    return (
        <LanguageContext.Provider value={{ getLocale }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext<LanguageContextValues | undefined>(
        LanguageContext,
    );

    if (!isDefined(context)) {
        throw new Error(`${LanguageContext.displayName} is undefined.`);
    }

    return context;
};
